import { i18n } from "@/locales";
import { EMAIL } from "@/utils/formRules";
import { SafetyOutlined, UserOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SendEmailCode } from "../../../SendEmailCode";
import { EmailScene } from "authing-js-sdk";
import { Rule } from "antd/lib/form";

export interface EmailValidateFormProps {
  required?: boolean
}

export const EmailValidateForm = (props: EmailValidateFormProps) => {
  const { required = false } = props;
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const emailInputRules: Rule[] = [{
    validator: (rule, value) => {
      if (value) {
        if (EMAIL.test(value)) {
          return Promise.resolve();
        } else {
          return Promise.reject(
            new Error(t("common.emailFormatError"))
          );
        }
      } else {
        return Promise.resolve();
      }
    },
  }];

  const emailCodeInputRules: Rule[] = [
    {
      validator: (_, value) => {
        if (value === undefined && required === false) {
          return Promise.resolve();
        }
        if (value.length !== window.__config__.verifyCodeLength) {
          return Promise.reject(
            t("login.inputFourVerifyCode", {
              length: window.__config__.verifyCodeLength,
            })
          );
        } else {
          return Promise.resolve();
        }
      },
    },
  ]

  if (required) {
    emailInputRules.splice(0, 0, {
      required: true,
      message: t("login.inputEmail"),
    })
    emailCodeInputRules.splice(0, 0, {
      required: true,
      message: t("login.inputFourVerifyCode", {
        length: window.__config__.verifyCodeLength,
      }),
    })
  }

  return (
    <>
      <Form.Item
        name="internal email:email"
        label={i18n.t("common.email")}
        key="sadf112323"
        rules={emailInputRules}
      >
        <Input
          autoComplete="tel"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          size="large"
          placeholder={t("login.inputEmail")}
          prefix={<UserOutlined style={{ color: "#ddd" }} />}
        />
      </Form.Item>

      <Form.Item
        style={{
          marginBottom: 0,
        }}
        name="internal email:code"
        key="sadf123"
        validateFirst
        rules={emailCodeInputRules}
      >
        <Input
          className={"authing-verify-code-input"}
          autoComplete="one-time-code"
          size="large"
          maxLength={window.__config__.verifyCodeLength}
          placeholder={t("login.inputFourVerifyCode", {
            length: window.__config__.verifyCodeLength,
          })}
          prefix={<SafetyOutlined style={{ color: "#ddd" }} />}
          addonAfter={
            <SendEmailCode email={email} scene={EmailScene.VerifyCode} />
          }
        />
      </Form.Item>
    </>
  );
};
